<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="wb-canvas">
        <svg class="wb-svg" viewBox="0 0 240 130" aria-hidden="true">
          <path
            class="wb-stroke wb-stroke--a"
            d="M20,90 C40,40 80,40 110,80 S180,90 220,40"
            fill="none"
            stroke="var(--accent)"
            stroke-width="3"
            stroke-linecap="round"
          />
          <path
            class="wb-stroke wb-stroke--b"
            d="M40,30 L80,30 L80,60 L40,60 Z"
            fill="none"
            stroke="#FF8A4C"
            stroke-width="2.5"
            stroke-linejoin="round"
          />
          <circle
            class="wb-stroke wb-stroke--c"
            cx="170"
            cy="100"
            r="14"
            fill="none"
            stroke="#3FB37F"
            stroke-width="2.5"
          />
        </svg>
      </div>
      <div class="wb-tools">
        <span class="wb-tool wb-tool--on"></span>
        <span class="wb-tool"></span>
        <span class="wb-tool"></span>
        <span class="wb-tool"></span>
      </div>
    </template>

    <template #audience>
      <span class="wb-phone-q"></span>
      <div class="wb-phone-canvas">
        <svg viewBox="0 0 100 60" class="wb-phone-svg" aria-hidden="true">
          <path
            class="wb-phone-stroke"
            d="M10,40 C20,20 40,20 50,40 S80,40 90,20"
            fill="none"
            stroke="var(--accent)"
            stroke-width="3"
            stroke-linecap="round"
          />
        </svg>
      </div>
      <div class="wb-phone-palette">
        <span class="wb-swatch wb-swatch--accent wb-swatch--on"></span>
        <span class="wb-swatch wb-swatch--orange"></span>
        <span class="wb-swatch wb-swatch--green"></span>
        <span class="wb-swatch wb-swatch--ink"></span>
      </div>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewWhiteboard',
  components: { PreviewFrame },
  props: { slide: { type: Object as PropType<SlideType>, required: true } },
})
</script>

<style scoped lang="scss">
.wb-canvas {
  flex: 1;
  border-radius: 8px;
  background:
    repeating-linear-gradient(
      90deg,
      rgba(15, 15, 20, 0.05) 0 1px,
      transparent 1px 18px
    ),
    repeating-linear-gradient(
      0deg,
      rgba(15, 15, 20, 0.05) 0 1px,
      transparent 1px 18px
    ),
    white;
  border: 1px solid rgba(15, 15, 20, 0.08);
  min-height: 130px;
  overflow: hidden;
}
.wb-svg { display: block; width: 100%; height: 100%; }

.wb-stroke {
  stroke-dasharray: 600;
  stroke-dashoffset: 600;
  animation: wb-draw 4s ease-in-out infinite;
}
.wb-stroke--a { animation-delay: 0s; }
.wb-stroke--b { animation-delay: 0.7s; stroke-dasharray: 200; stroke-dashoffset: 200; }
.wb-stroke--c { animation-delay: 1.4s; stroke-dasharray: 100; stroke-dashoffset: 100; }

.wb-tools {
  display: flex;
  gap: 8px;
  padding: 4px;
}
.wb-tool {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  background: rgba(15, 15, 20, 0.06);
}
.wb-tool--on {
  background: var(--accent);
}

/* ---- Audience phone ---- */
.wb-phone-q {
  display: block;
  height: 8px;
  width: 70%;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.18);
  margin-bottom: 2px;
}
.wb-phone-canvas {
  border-radius: 8px;
  background: white;
  border: 1px solid rgba(15, 15, 20, 0.08);
  height: 70px;
  overflow: hidden;
}
.wb-phone-svg { display: block; width: 100%; height: 100%; }
.wb-phone-stroke {
  stroke-dasharray: 240;
  stroke-dashoffset: 240;
  animation: wb-draw 4s ease-in-out infinite;
}
.wb-phone-palette {
  display: flex;
  justify-content: center;
  gap: 8px;
  padding: 2px;
}
.wb-swatch {
  width: 16px;
  height: 16px;
  border-radius: 999px;
  border: 1px solid rgba(15, 15, 20, 0.08);
}
.wb-swatch--accent { background: var(--accent); }
.wb-swatch--orange { background: #FF8A4C; }
.wb-swatch--green { background: #3FB37F; }
.wb-swatch--ink { background: #1A1A2E; }
.wb-swatch--on {
  box-shadow: 0 0 0 2px white, 0 0 0 4px var(--accent);
}

@keyframes wb-draw {
  0%   { stroke-dashoffset: var(--len, 600); }
  60%  { stroke-dashoffset: 0; }
  90%  { stroke-dashoffset: 0; }
  100% { stroke-dashoffset: 0; }
}

@media (prefers-reduced-motion: reduce) {
  .wb-stroke, .wb-phone-stroke {
    animation: none;
    stroke-dashoffset: 0;
  }
}
</style>
